import type { ViewController } from '@/engine/app/View.controller';
import type { ViewsService } from '@/engine/app/Views.service';
import { ImagesMode } from '@/engine/app/modules/images/interfaces';
import { useMemo } from 'react';

export const useImageModeHandlers = (
  viewsService: ViewsService,
  viewController: ViewController
): Record<ImagesMode, () => void> => {
  return useMemo(
    () => ({
      [ImagesMode.MPR]: (): void => {
        // TODO: MPR images mode should always deselect centerline!
        //   fix code duplications with:
        //     useImageModeHandlers.ts
        //     OrientationPresets.controller.ts
        //     cinelooControlController.ts
        //     viewModelSelectionReactionStrategiesProvider.ts
        viewController.setActiveCenterLineDescriptor(undefined);
      },
      [ImagesMode.POLYLINE]: (): void => {
        // TODO: POLYLINE images mode should always select centerline!
        //   fix code duplications with:
        //     useImageModeHandlers.ts
        //     OrientationPresets.controller.ts
        //     cinelooControlController.ts
        //     viewModelSelectionReactionStrategiesProvider.ts
        const centerLine = viewsService.currentViewOrThrow.getCenterLines().at(0);
        if (!centerLine) {
          console.warn('Centerline is undefined');
          return;
        }
        viewController.setActiveCenterLineDescriptor(centerLine.descriptor);
      }
    }),
    [viewsService, viewController]
  );
};
